import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';
import { colors } from '@cimpress/react-components';
import Breadcrumbs from '../common/breadcrumbs/Breadcrumbs';
import ErrorBoundary from './ErrorBoundary';

const containerStyle = css`
  background-color: #fff;
  border: 1px solid ${colors.platinum};
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  padding: 45px;
`;

/**
 * BasicLayout is a layout with breadcrumbs
 * and card component with white background.
 */
class BasicLayout extends React.Component {
  render() {
    const { noStyle, children, className, title } = this.props;

    const breadcrumbs = <Breadcrumbs />;

    return (
      <div>
        <div className="container-fluid">
          <div className="breadcrumbs">{breadcrumbs}</div>
          {title && <h2>{title}</h2>}
          <ErrorBoundary>
            <div className={`${className + ' ' || ''}${noStyle ? '' : containerStyle}`}>{children}</div>
          </ErrorBoundary>
        </div>
      </div>
    );
  }
}

BasicLayout.propTypes = {
  children: PropTypes.node,
  fluid: PropTypes.bool
};

export default BasicLayout;
